import { FormControl, ValidationErrors } from '@angular/forms';

import { Password } from './password';

type ValidationError = ValidationErrors | null;

export class CreatePasswordValidator {
    public static passwordComplexity(passwordField: FormControl<string>): ValidationError {
        const password = new Password(passwordField.value, '');
        if (!password.isComplexityValid()) {
            return {
                complexity: {
                    valid: false
                }
            };
        }
        return null;
    }

    public static passwordSpacePosition(passwordField: FormControl<string>): ValidationError {
        const password = new Password(passwordField.value, '');
        if (!password.isSpaceValid()) {
            return {
                space: {
                    valid: false
                }
            };
        }
        return null;
    }

    public static passwordForbiddenCharacters(passwordField: FormControl<string>): ValidationError {
        const password = new Password(passwordField.value, '');
        if (password.forbiddenChar) {
            return {
                forbiddenCharacters: {
                    valid: false
                }
            };
        }
        return null;
    }

    public static passwordNotEqualToValidatePassword(passwordField: FormControl<string>): null {
        const validatePasswordField = passwordField.root.get('validatePassword');
        if (validatePasswordField != null) {
            validatePasswordField.updateValueAndValidity();
        }
        return null;
    }

    public static validatePasswordNotEqualToPassword(validatePasswordField: FormControl<string>): ValidationError {
        const validatePasswordValue = validatePasswordField.value;
        if (validatePasswordValue === '') {
            return null;
        }

        const passwordField = validatePasswordField.root.get('password');
        if (passwordField == null) {
            return null;
        }

        return validatePasswordValue === passwordField.value
            ? null
            : {
                  passwordsNotEqual: {
                      valid: false
                  }
              };
    }
}
